import type { DatovkaApiType } from '@gov-nx/api';
import { useDataBoxStoreLists } from '@gov-nx/store';

export const useDataBoxes = (
	requiredDataBoxes: DatovkaApiType['typSchranky'][]
) => {
	const { getConnectedDataBoxesByTypes } = useDataBoxStoreLists();
	const dataBoxes = getConnectedDataBoxesByTypes(requiredDataBoxes);
	const isDataBoxConnected = dataBoxes.length > 0;

	return { isDataBoxConnected, requiredDataBoxes };
};
